import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFlex = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "27px",
	height: "49px",
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 30.5 50.6",
	style: { enableBackground: "new 0 0 30.5 50.6" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st0{fill:#FFFFFF;}\n	.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n	.st2{clip-path:url(#SVGID_00000005958817602226850520000004438104031968588217_);}\n	.st3{clip-path:url(#SVGID_00000126284466455656711670000013856487953053248151_);}\n	.st4{fill:#F2F2F2;}\n	.st5{fill:#BDB6B8;}\n	.st6{fill:#1A1A1A;}\n	.st7{fill:#ADA8AA;}\n	.st8{fill:#262424;}\n	.st9{fill:#1E8273;}\n	.st10{fill:#239281;}\n	.st11{fill:#262626;}\n	.st12{fill:#0F0F0F;}\n	.st13{fill:#212226;}\n	.st14{opacity:0.25;}\n	.st15{clip-path:url(#SVGID_00000138541592012682290600000003072244705150675349_);}\n	.st16{opacity:0.15;}\n	.st17{clip-path:url(#SVGID_00000178893251901415931500000005714078760364661655_);}\n	.st18{clip-path:url(#SVGID_00000000205615253155904390000010719743209762837156_);}\n	.st19{clip-path:url(#SVGID_00000074441760450635722610000017798640957564191117_);}\n	.st20{clip-path:url(#SVGID_00000082343202325064829980000000704814403593936547_);}\n	.st21{clip-path:url(#SVGID_00000060002913055590455700000015635143845972633489_);}\n	.st22{fill:#DFDFDE;}\n	.st23{fill:#1d3943;}\n	.st24{fill:#B7CDC8;}\n"
	}), /* @__PURE__ */ _jsxs("g", {
		id: "Group_4425",
		transform: "translate(0 0)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1",
				className: "st22",
				d: "M13.7,30.2c-2.3,0-4.5-0.1-6.8-0.1c-2.3,0-4-0.9-4.5-2.9c-0.7-1.9-0.1-4,1.3-5.4 C9.6,15.5,15.4,9.2,21.3,2.9c2-2.1,4.7-2.3,6.3-0.3c1.8,2.1,1.6,4.8-0.5,7.1c-3.3,3.6-6.7,7.1-10,10.7c-0.3,0.3-0.6,0.7-0.9,1.1 c2.6,0,5.1,0.1,7.5,0.1c1.8,0,2.7,1.4,4.1,3c1.2,1.5,0.2,3.8-1.1,5.2c-1.9,1.9-3.7,3.7-5.9,5.8c2.2,2.3,4.1,4.4,6,6.4 c2.5,2.8,2,6.5-1.2,8c-1.6,0.7-3.5,0.3-4.6-1.1c-2.9-3.3-5.9-6.6-8.8-9.9c-1.8-1.9-1.8-4.8,0.1-6.7c0.5-0.6,1.1-1.1,1.6-1.6 L13.7,30.2"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2",
				className: "st23",
				d: "M9.7,34.6L23,21c0.4-0.4,1.1-0.5,1.6,0c0,0,0,0,0,0l4.6,4.7c0.4,0.5,0.4,1.2,0,1.6L16,40.9 c-0.4,0.4-1.1,0.5-1.6,0c0,0,0,0,0,0l-4.6-4.7C9.3,35.7,9.3,35,9.7,34.6"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_3",
				className: "st24",
				d: "M20.4,44.9c0.6-2.3,3-3.7,5.4-3.1c0,0,0,0,0.1,0c2.4,0.7,3.7,3.2,3,5.5c-0.6,2.3-3,3.7-5.4,3.1 c0,0,0,0-0.1,0C21.1,49.7,19.7,47.2,20.4,44.9"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4",
				className: "st10",
				d: "M30.1,6.7l-23.6,24c-0.4,0.4-1.1,0.4-1.6,0c0,0,0,0,0,0L0.3,26c-0.4-0.5-0.4-1.2,0-1.6l23.6-24 c0.4-0.4,1.1-0.4,1.6,0c0,0,0,0,0,0l4.7,4.8C30.6,5.5,30.6,6.3,30.1,6.7"
			})
		]
	})]
});
export { SvgIconFlex as ReactComponent };
